import { AwsBucketConfig } from '../types/types';
import { config } from 'packages/config';

const awsBucketConfig: AwsBucketConfig = {
  region: config.ENV.AWS.REGION,
  accessKeyId: config.ENV.AWS.S3.HOLTER_KEY_ID,
  secretAccessKey: config.ENV.AWS.S3.HOLTER_KEY,
};

export { awsBucketConfig };
